import script from "./IpInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./IpInfo.vue?vue&type=script&setup=true&lang=js"

import "./IpInfo.vue?vue&type=style&index=0&id=74b47d96&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74b47d96"]])

export default __exports__